"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendHook = exports.fetcher = void 0;
var react_1 = require("react");
var errors_1 = require("./commerce/utils/errors");
var use_login_1 = __importDefault(require("./commerce/use-login"));
var use_customer_1 = __importDefault(require("./use-customer"));
var defaultOpts = {
    url: '/api/bigcommerce/customers/login',
    method: 'POST',
};
// const loginMutation = /* GraphQL */ `mutation login($email: String!, $password: String!) { login(email: $email,  password: $password) { result } } `
var fetcher = function (options, _a, fetch) {
    var email = _a.email, password = _a.password;
    if (!(email && password)) {
        throw new errors_1.CommerceError({
            message: 'A first name, last name, email and password are required to login',
        });
    }
    return fetch(__assign(__assign(__assign({}, defaultOpts), options), { body: { email: email, password: password } }));
};
exports.fetcher = fetcher;
var loginMutation = /* GraphQL */ "\nmutation login($email: String!, $password: String!) {\n  login(email: $email, password: $password) {\n    result\n    customer {\n      entityId\n      email\n    }\n  }\n}\n";
var token = process.env.BIGCOMMERCE_STOREFRONT_API_TOKEN_GRAPHQL;
var url = process.env.BIGCOMMERCE_STOREFRONT_API_URL;
var _login = function (_a) {
    var email = _a.email, password = _a.password;
    return __awaiter(void 0, void 0, void 0, function () {
        var res, data, resUser, json, _b;
        var _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, fetch(url, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            'Authorization': "Bearer ".concat(token),
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            query: loginMutation,
                            variables: { email: email, password: password },
                        }),
                    })];
                case 1:
                    res = _g.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _g.sent();
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, 7, 8, 9]);
                    return [4 /*yield*/, fetch('/api/bigcommerce/customers/check/' + email, {
                            method: 'GET',
                            credentials: 'include',
                        })];
                case 4:
                    resUser = _g.sent();
                    return [4 /*yield*/, resUser.json()];
                case 5:
                    json = _g.sent();
                    return [4 /*yield*/, fetch('/api/bigcommerce/customers/channel/' + json.customer_id, {
                            method: 'GET',
                            credentials: 'include',
                        })];
                case 6:
                    _g.sent();
                    return [3 /*break*/, 9];
                case 7:
                    _b = _g.sent();
                    console.log('error trying to change channels');
                    return [3 /*break*/, 9];
                case 8: return [2 /*return*/, {
                        result: (_d = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.login) === null || _d === void 0 ? void 0 : _d.result,
                        customer: (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.login) === null || _f === void 0 ? void 0 : _f.customer
                    }];
                case 9: return [2 /*return*/];
            }
        });
    });
};
function extendHook(customFetcher) {
    var useLogin = function () {
        var revalidate = (0, use_customer_1.default)().revalidate;
        var fn = (0, use_login_1.default)(defaultOpts, customFetcher);
        return (0, react_1.useCallback)(function login(input) {
            return __awaiter(this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, _login(input)];
                        case 1:
                            data = _a.sent();
                            return [4 /*yield*/, revalidate()];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, data];
                    }
                });
            });
        }, [fn]);
    };
    useLogin.extend = extendHook;
    return useLogin;
}
exports.extendHook = extendHook;
exports.default = extendHook(exports.fetcher);
